import React from "react";
import SbEditable from "storyblok-react";
import Heading from "src/components/Heading";
import RichText from "src/utils/RichText";
import CookieValue from "src/utils/CookieValue";
import CtaReferrer from "./CtaReferrer";

const GatedContentForm = ({ blok }) => {
  const redirectUrl = CookieValue("gated_content_redirect_url");

  const onFromSubmit = () => {
    window?.dataLayer?.push({
      event: "form-submission",
      formName: "gated-content",
    });
    if (redirectUrl) {
      window?.dataLayer?.push({
        event: "download",
        url: redirectUrl,
      });        
      window.open(redirectUrl, "noopener,noreferrer");
    }
  };
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative bg-white">
        <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
          <div className="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-16 xl:pl-28">
            <div className="mx-auto">
              <Heading
                size="h1"
                className="text-4xl lg:text-5xl tracking-normal text-red mb-2"
              >
                {blok.title}
              </Heading>
              <span className="mt-3 text-base font-body leading-5">
                <RichText>{blok.description}</RichText>
              </span>
              <form
                className="mt-12 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8 max-w-4xl font-display"
                name={"gated_content"}
                action={"/gated-content/thank-you/"}
                method="POST"
                netlify-honeypot="bot-field"
                data-netlify="true"
                onSubmit={() => onFromSubmit()}
              >
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"first_name"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">First Name</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"text"}
                      name={"first_name"}
                      id={"first_name"}
                      required
                      autoComplete={"given-name"}
                      placeholder={"First Name*"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"last_name"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">Last Name</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"text"}
                      name={"last_name"}
                      id={"last_name"}
                      required
                      autoComplete={"family-name"}
                      placeholder={"Last Name*"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"job_title"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">Job title</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"text"}
                      name={"job_title"}
                      id={"job_title"}
                      required
                      autoComplete={"organization-title"}
                      placeholder={"Job title*"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"email"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">Email</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"email"}
                      name={"email"}
                      id={"email"}
                      required
                      autoComplete={"email"}
                      placeholder={"Email*"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"telephone"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">Telephone</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"text"}
                      name={"telephone"}
                      id={"telephone"}
                      required
                      autoComplete={"tel"}
                      placeholder={"Telephone*"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <div className={"sm:col-span-2"}>
                  <label
                    htmlFor={"company_name"}
                    className="block font-light text-black"
                  >
                    <span className="sr-only">Company name</span>
                  </label>
                  <div className="mt-1">
                    <input
                      type={"text"}
                      name={"company_name"}
                      id={"company_name"}
                      autoComplete={"organization"}
                      placeholder={"Company name"}
                      className="block w-full shadow-sm py-3 px-4 placeholder-placeholdergrey focus:ring-darkred focus:border-darkred border-[#e0e0e0] text-lg"
                    />
                  </div>
                </div>
                <CtaReferrer />
                <div>
                  <input type="hidden" name="form-name" value="gated_content" />
                  <button
                    type="submit"
                    className="cursor-pointer inline-flex justify-center items-center px-5 py-3 line-crop font-display tracking-[0.08em] text-white uppercase transition duration-300 text-lg !leading-tight bg-red hover:bg-darkred"
                  >
                    Submit{" "}
                    <i className="fas fa-chevron-right cursor-pointer ml-3 text-xs inline"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default GatedContentForm;
